<template>
  <expansion-panel>
    <template #title>Unlock Driver's Self Check-In</template>
    <template #header-right><v-icon size="small">mdi-lock</v-icon></template>
    <template #content>
      <div class="d-flex">
        <div class="blurred">
          <div class="field-value">
            <strong>Driver's Name</strong>
            <div>Alex Johnson</div>
          </div>
          <div class="field-value">
            <strong>Driver's Phone Number</strong>
            <div>+1 (555) 234-5678</div>
          </div>
          <div class="field-value">
            <strong>Trucking Company</strong>
            <div>Swiftlane Logistics</div>
          </div>
          <div class="field-value">
            <strong>Trailer Number</strong>
            <div>TR-4567</div>
          </div>
          <div class="field-value">
            <strong>Fuel Type</strong>
            <div>Diesel</div>
          </div>
        </div>
        <div class="d-flex flex-1 justify-center align-center">
          <v-card class="ad-card" width="330" elevation="0">
            <v-card-title class="pa-0">
              <p class="text-break mb-2">
                Upgrade
                <strong>Gate Management</strong>
                to gain access to:
              </p>
            </v-card-title>
            <v-card-text>
              <p class="mb-1">
                <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
                Fast
                <strong>self-check in for drivers</strong>
              </p>
              <p class="mb-1">
                <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
                <strong>Real-time alerts</strong>
                for all arrivals
              </p>
              <p class="mb-1">
                <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
                In-app
                <strong>SMS chat with drivers</strong>
              </p>
              <p class="mb-1">
                <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
                Management of
                <strong>unplanned arrivals</strong>
              </p>
              <p class="mb-1">
                <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
                <strong>Yard Management</strong>
                for assigning assets
              </p>
            </v-card-text>
            <v-card-actions>
              <div class="text-center full-width">
                <p>
                  <v-btn
                    target="_blank"
                    rel="noopener"
                    class="small bg-secondary"
                    @click="handleGMCTAClick"
                    :href="GATE_MANAGEMENT_SALES_URL">
                    <span class="text-white">
                      <v-icon size="small" class="mr-2">mdi-open-in-new</v-icon>
                      Learn More
                    </span>
                  </v-btn>
                </p>
                <p>
                  <a @click="handleGMRequestClick()">Request a trial</a>
                </p>
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </template>
  </expansion-panel>
</template>

<script>
import ExpansionPanel from '@/components/elements/ExpansionPanel.vue';
import { defineComponent } from 'vue';
import { useGMAd } from '@/composables';
import { GATE_MANAGEMENT_SALES_URL } from '@nova/core';

export default defineComponent({
  name: 'AppointmentDetailsGateYardDisclaimer',
  components: { ExpansionPanel },
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { handleGMCTAClick, handleGMRequestClick } = useGMAd(
      props.appointment.warehouse,
      props.appointment.org ?? props.appointment.dock?.warehouse?.org,
      'Gate Yard Tab'
    );
    return { handleGMCTAClick, handleGMRequestClick, GATE_MANAGEMENT_SALES_URL };
  }
});
</script>
